import React from "react";
import HowItWorks from "./HowItWorks";
import FormExample from "./FormExample";
import FeesSection from "./FeesSection";
import FAQ from "./FAQ";
import ProceedSection from "./ProceedSection";

const MedicalFormArea = () => {
  return (
    <>
      <section id="medicalform-area">
        <div className="container">
          <HowItWorks />
          <FormExample />
          <FeesSection />
          <ProceedSection />
          <FAQ />
        </div>
      </section>
    </>
  );
};

export default MedicalFormArea;
